export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref13356.ebfc1530.jpg";